// extracted by mini-css-extract-plugin
export var dataCell = "_o8-2";
export var dataRow = "_o8-0";
export var headerRow = "_o8-1";